import { useEffect, useState } from 'react'
import { httpsCallable, getFunctions } from 'firebase/functions'

const DEFAULT_KEY = [
  { id: 'all', name: 'All' }
]

const useGetApiKeys = (skip = false) => {
  const [keys, setKeys] = useState([])
  const [loading, setLoading] = useState(!skip)

  useEffect(() => {
    if (skip) return
    const fetchKeys = async () => {
      const getKeys = httpsCallable(getFunctions(), 'getKeys')
      try {
        const res = await getKeys()
        setKeys(res.data.sort((a, b) => a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1))
        setLoading(false)
      } catch (error) {
        console.error(error)
        setLoading(false)
      }
    }
    fetchKeys()
  }, [skip])
  return {
    keys: [
      ...DEFAULT_KEY,
      ...keys
    ],
    loading
  }
}

export default useGetApiKeys
